import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreUsersIdMapReducers } from './_idMap';

import { coreSalesforceUsersReducers, coreSalesforceUsersWatchers } from './salesforce';
import { coreUsersAdminReducers, coreUsersAdminWatchers } from './admin';
import { coreUsersAllReducers, coreUsersAllWatchers } from './all';
import { coreUsersByIdReducers, coreUsersByIdWatchers } from './_id';
import { coreUsersCurrentReducers, coreUsersCurrentWatchers } from './current';

export const coreUsersReducers = combineReducers({
	admin: coreUsersAdminReducers,
	all: coreUsersAllReducers,
	byId: coreUsersByIdReducers,
	byIdMap: coreUsersIdMapReducers,
	current: coreUsersCurrentReducers,
	salesforce: coreSalesforceUsersReducers
});

export const coreUsersWatchers = combineAllWatchers([
	coreUsersAdminWatchers,
	coreUsersAllWatchers,
	coreUsersByIdWatchers,
	coreUsersCurrentWatchers,
	coreSalesforceUsersWatchers
]);
